import { makeStyles } from '@barracuda-internal/bds-core'

const commonStyles = {
  display: 'inline-block',
  cursor: 'default'
}

export default makeStyles(theme => ({
  infoDialog: {
    ...commonStyles,
    minWidth: 500
  },
  infoDialogText: {
    ...commonStyles,
    cursor: 'pointer',
    color: theme.palette.secondary.light
  }
}))
